import pre from './pre';
import cart from './cart.vue';
import config from './config';
import addon from './addon';
import success from './success.vue';
export default {
  pre,
  components: {
    addon,
    config,
    cart,
    success,
  },
};
